/* eslint-disable react-hooks/exhaustive-deps */
import "./App.css";
import "./styles/globals.css";
import Routing from "./routing/Routing";

function App() {
  return (
    <>
      <Routing />
    </>
  );
}

export default App;
